import { parseResponse } from '$lib/client/responseHelpers';

import { client, silentClient } from '@api/client';
import type { CloseRoom, RatingUser, RoomUserStats } from '@api/types';

export const startRoomSearching = async () => {
    const data =  await client.POST('/room/start-search', {});
    return parseResponse(data);
};

export const stopRoomSearching = async () => {
    const data =  await client.POST('/room/stop-search', {});
    return parseResponse(data);
};

export const initRoom = async (roomId: string) => {
    const data =  await client.GET('/room/{roomId}/init', {
        params: {
            path: { roomId },
        },
    });
    return parseResponse(data);
};

export const updateBalance = async (roomId?: string) => {
    const data = await client.GET('/room/balance', {
        params: {
            query: { roomId },
        },
    });
    return parseResponse(data);
};

export const getRoomData = async (roomId: string) => {
    const data = await client.GET('/room/{roomId}/data', {
        params: {
            path: { roomId },
        },
    });
    return parseResponse(data);
};

export const closeRoom = async (roomId: string, closeRoomBody: CloseRoom) => {
    const data = await client.POST('/room/{roomId}/close', {
        params: {
            path: { roomId },
        },
        body: closeRoomBody,
    });
    return parseResponse(data);
};

export const nextRoom = async (roomId: string, closeRoomBody: CloseRoom) => {
    const data = await client.POST('/room/{roomId}/next', {
        params: {
            path: { roomId },
        },
        body: closeRoomBody,
    });
    return parseResponse(data);
};

export const sendSnapshot = (roomId: string, snapshot: string) => {
    silentClient.POST('/room/snapshot', {
        body: {
            roomId,
            data: snapshot,
        },
    });
};

export const rateOperator = async (userId: string, roomId: string, ratingUser: RatingUser) => {
    return client.POST('/room/{roomId}/rate-operator/{userId}', {
        params: {
            path: { roomId, userId },
        },
        body: ratingUser,
    });
};

export const rateUser = async (userId: string, roomId: string, ratingUser: RatingUser) => {
    return client.POST('/room/{roomId}/rate-user/{userId}', {
        params: {
            path: { roomId, userId },
        },
        body: ratingUser,
    });
};

export const sendRoomUserStreamStats = (roomId: string, stats: RoomUserStats) => {
    silentClient.POST('/room/{roomId}/stats', {
        params: {
            path: { roomId },
        },
        body: stats,
    });
};

